import { createReducer } from '@reduxjs/toolkit' ;
import {createAccountRequest, createAccountSuccess, createAccountFailure, activeusername, activeemail } from '../../actions/adminFlow/createAccountAction';


const initialState = {
	loading: false,
	error: null,
	responseData: null,
	
	};
	
const createAccountReducer = createReducer(initialState, (builder) => {

	builder
		.addCase(createAccountRequest, (state) => {
			state.loading = true;
			state.error = null;
			state.responseData = null;
		})
		.addCase(createAccountSuccess, (state, action) => {
			state.loading = false;
			state.responseData = action.payload;
		})
		.addCase(createAccountFailure, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		})

});
	
export default createAccountReducer;
